import Img from "../../assets/image/index";
import Icons from "../../assets/icon";
import AppStoreIcon from "../../assets/image/App_Store_2x.png"; // Add this import
import GooglePlayIcon from "../../assets/image/Google_Play_2x.png"; // Add this import

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaTiktok,
} from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri";
import { Link } from "react-router";
import GemLogo from "../gemLogo";
import Functions from "./index.functino";

import { FormInput } from "../../components";


const Footer = () => {
  const {  
    control,
    onSubmit,
    customSubmitHandler,
    currentYear, 
    navigate, 
    isActive,
    errors,

  } = Functions();
  return (
    <div className="bg-[#121212] rounded-tl-[40px] rounded-tr-[40px] sm:pt-10 xs:pt-10 sm:mt-4 lg:mt-5 lg:pt-14 xl:pt-16   relative">
      <div className="lg:px-5 xl:px-10 xs:px-3 sm:px-6 flex xs:flex-col justify-between items-start ">
        <div className="sm:w-48 lg:w-2/6 flex justify-center items-center">
          <div className="">
            <div className="xs:mb-2 sm:pb-2 lg:pb-8">
              <GemLogo />
            </div>
            <div className="xs:mb-2 sm:pb-2 lg:pb-8">
              <p className="text-[#929292] font-onestLight text-sm sm:text-sm lg:text-sm xl:text-base">
                GEM is using volatile innovation in crowdfunding regulations to
                build an arts and entertainment organization claimed by the
                FANS, as we are positive that an Entertainment entity possessed
                by its customers has an edge to the one whose owners are
                millionaires and billionaires.,
              </p>
            </div>
            <div className="flex flex-wrap gap-x-3.5 gap-y-3 xs:pt-3   " >
                <a
                  href="https://www.facebook.com/iamgemglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#1877F2] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-end transition-all duration-300 transform hover:scale-110 hover:shadow-md hover:bg-[#1877F2cb]"
                >
                  <FaFacebookF className="xs:text-xl sm:text-lg lg:text-2xl xl:text-3xl" />
                </a>
                <a
                  href="https://www.instagram.com/iamgemglobal/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary rounded-full cursor-pointer gradient-container xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-md "
                >
                  <FaInstagram className="xs:text-base lg:text-xl sm:text-sm xl:text-2xl" />
                </a>
                <a
                  href="https://www.linkedin.com/company/iamgemglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#0B69C7] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-md hover:bg-[#084D93cb]"
                >
                  <FaLinkedinIn className="xs:text-base sm:text-sm lg:text-lg xl:text-xl" />
                </a>
                <a
                  href="https://x.com/iamgemglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-black text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-md hover:bg-[#0A95D0cb]"
                >
                  <RiTwitterXLine className="xs:text-sm sm:text-sm lg:text-lg xl:text-xl" />
                </a>
                <a
                  href="https://youtube.com/@gemflix"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#F20000] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-md hover:bg-[#d90000cb]"
                >
                  <FaYoutube className="xs:text-base lg:text-xl sm:text-base xl:text-2xl" />
                </a>
                <a
                  href="https://www.tiktok.com/@iamgemglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#000000] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-md group hover:bg-[#25F4EE]"
                >
                  <FaTiktok className="xs:text-base lg:text-xl sm:text-base xl:text-xl text-secondary group-hover:text-[#000000]" />
                </a>
              </div>
            {/* <div className="xs:mb-2 sm:pb-2 lg:pb-8">
              <p className="text-[#929292] font-onestRegular text-sm">
                Copyright © {currentYear} Global Entertainment Movement
              </p>
              <p className="text-[#929292] font-onestRegular text-sm">
                <span
                  className="underline hover:text-secondary cursor-pointer"
                  onClick={() => navigate("/terms-and-conditions")}
                >
                  Terms and Conditions
                </span>{" "}
                |{" "}
                <span
                  className="underline hover:text-secondary cursor-pointer"
                  onClick={() => navigate("/privacy-policy")}
                >
                  Privacy Policy
                </span>
              </p>
            </div> */}
          </div>
        </div>
        <div className="sm:w-36 lg:w-52 hide-mobile" style={{ zIndex: "5" }}>
          <div >
            {/* <h4 className='font-unboundedBold text-secondary xs:text-base sm:text-base  xl:text-2xl capitalize xs:mb-3 sm:mb-8 lg:mb-5'>Company</h4>
             <h4 className="font-unboundedBold text-secondary sm:text-base  xl:text-2xl capitalize xs:mb-3 sm:mb-8 lg:mb-5"> */}
              <h4 className='font-unboundedBold text-secondary xs:text-base sm:text-base  xl:text-2xl capitalize xs:mb-3 sm:mb-8 lg:mb-5'> 
              Quick Links
            </h4>
          </div>
          <ul>
            <Link to="/">
              <li
                className={` hover:font-onestBold xs:mb-1 sm:mb-1 hover:text-[#FC7336] text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 cursor-pointer ease-in-out lg:mb-2 ${
                  isActive("/")
                    ? "font-onestBold text-[#FC7336]"
                    : "font-onestRegular"
                }`}
              >
                Home
              </li>
            </Link>
            <Link to="/team">
              <li
                className={` hover:font-onestBold xs:mb-1 sm:mb-1 hover:text-[#FC7336] text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 cursor-pointer ease-in-out lg:mb-2 ${
                  isActive("/team")
                    ? "font-onestBold text-[#FC7336]"
                    : "font-onestRegular"
                }`}
              >
                Team
              </li>
            </Link>
            <Link to="/packages">
              <li
                className={` hover:font-onestBold xs:mb-1 sm:mb-1 hover:text-[#FC7336] text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 cursor-pointer ease-in-out lg:mb-2 ${
                  isActive("/packages")
                    ? "font-onestBold text-[#FC7336]"
                    : "font-onestRegular"
                }`}
              >
                Packages
              </li>
            </Link>
            <Link to="/news">
              <li
                className={` hover:font-onestBold xs:mb-1 sm:mb-1 hover:text-[#FC7336] text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 cursor-pointer ease-in-out lg:mb-2 ${
                  isActive("/news")
                    ? "font-onestBold text-[#FC7336]"
                    : "font-onestRegular"
                }`}
              >
                News
              </li>
            </Link>
            <Link to="/event">
              <li
                className={` hover:font-onestBold xs:mb-1 sm:mb-1 hover:text-[#FC7336] text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 cursor-pointer ease-in-out lg:mb-2 ${
                  isActive("/event")
                    ? "font-onestBold text-[#FC7336]"
                    : "font-onestRegular"
                }`}
              >
                Events
              </li>
            </Link>
            <Link to="/talent">
              <li
                className={` hover:font-onestBold xs:mb-1 sm:mb-1 hover:text-[#FC7336] text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 cursor-pointer ease-in-out lg:mb-2 ${
                  isActive("/talent")
                    ? "font-onestBold text-[#FC7336]"
                    : "font-onestRegular"
                }`}
              >
                Talent
              </li>
            </Link>
            <Link to="/contact-us">
              <li
                className={` hover:font-onestBold xs:mb-1 sm:mb-1 hover:text-[#FC7336] text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 cursor-pointer ease-in-out lg:mb-2 ${
                  isActive("/contact-us")
                    ? "font-onestBold text-[#FC7336]"
                    : "font-onestRegular"
                }`}
              >
                Contact us
              </li>
            </Link>
          </ul>
        </div>
        <div className="sm:w-36 lg:w-52 hide-mobile" style={{ zIndex: "5" }}>
          <div>
            <h4 className="font-unboundedBold text-secondary sm:text-base  xl:text-2xl capitalize xs:mb-3 sm:mb-8 lg:mb-5">
              Locations
            </h4>
          </div>
          <ul>
            {/* <li
              className={` hover:font-onestBold font-onestRegular xs:mb-1 sm:mb-1 hover:text-[#FC7336] text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 cursor-pointer ease-in-out capitalize lg:mb-2`}
            >
              United States
            </li> */}
            <li
              className={` font-onestRegular xs:mb-1 sm:mb-1 text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 ease-in-out capitalize lg:mb-2`}
            >
              United States
            </li>
            <li
              className={` font-onestRegular xs:mb-1 sm:mb-1 text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 ease-in-out capitalize lg:mb-2`}
            >
              Canada 
            </li>
            <li
              className={` font-onestRegular xs:mb-1 sm:mb-1 text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 ease-in-out capitalize lg:mb-2`}
            >
              United Kingdom
            </li>
            <li
              className={` font-onestRegular xs:mb-1 sm:mb-1 text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 ease-in-out capitalize lg:mb-2`}
            >
              Saudi Arabia
            </li>
            <li
              className={` font-onestRegular xs:mb-1 sm:mb-1 text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 ease-in-out capitalize lg:mb-2`}
            >
              United Arab Emirates
            </li>
            <li
              className={` font-onestRegular xs:mb-1 sm:mb-1 text-[#929292] text-sm sm:text-base xl:text-lg transition-all duration-300 ease-in-out capitalize lg:mb-2`}
            >
              Pakistan
            </li>
          </ul>
        </div>
        <div className="sm:w-48 lg:w-3/12 flex-col" style={{ zIndex: "5" }}>
          <div className="w-full">
            <div>
              <h4 className="font-unboundedBold text-secondary xs:text-base sm:text-base xl:text-2xl capitalize xs:mb-3 sm:mb-8 lg:mb-2 margin-mob">
                Get in touch
              </h4>
            </div>
            <div>
              <p className="font-onestLight text-[#929292] text-sm">
                Subscribe to our newsletter and get the inside scoop!
              </p>
            </div>
            <form onSubmit={customSubmitHandler} noValidate>
              <div className="relative xs:mt-3 sm:mt-3 lg:mt-5">
                <FormInput 
                  className="w-full outline-none xs:h-10 xs:rounded-lg xs:px-3 sm:h-8 lg:h-12 sm:rounded-lg rounded-xl sm:pl-3 sm:pr-8 lg:px-5 xs:text-xs sm:text-xs lg:text-sm bg-[#242424] text-[#929292] font-onestLight"
                  placeholder="Enter Your Email"

                  // label={"Email Address"}
                  control={control}
                  name="email"
                  type="email" 
                  isMandatory={true}
                  pattern={{
                    value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                    message: "Please enter a valid email address",
                  }}
                  errors={errors}
                />
                <button
                  type="submit"
                  className="absolute sm:top-1.5 xs:top-2.5 xs:right-2 sm:right-2 lg:top-3.5 xl:top-3 -rotate-45 lg:right-5"
                >
                  <img
                    className="xs:w-4 sm:w-4 xl:w-5 lg:w-4"
                    src={Icons.submitIcon}
                    alt="submitIcon"
                  />
                </button>
              </div>
            </form>
            <div className="flex items-start justify-center flex-col">
              {/* <h4 className="font-unboundedBold text-secondary xs:text-base sm:text-base xl:text-2xl capitalize xs:mt-3 sm:mt-3 lg:mt-8 margin-mob">
                Follow Us
              </h4>   <div className="flex flex-wrap gap-x-3.5 gap-y-3 xs:pt-3 sm:pt-3 lg:pt-6">
                <a
                  href="https://www.facebook.com/iamgemglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#1877F2] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-end transition-all duration-300 transform hover:scale-110 hover:shadow-md hover:bg-[#1877F2cb]"
                >
                  <FaFacebookF className="xs:text-xl sm:text-lg lg:text-2xl xl:text-3xl" />
                </a>
                <a
                  href="https://www.instagram.com/iamgemglobal/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary rounded-full cursor-pointer gradient-container xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-md "
                >
                  <FaInstagram className="xs:text-base lg:text-xl sm:text-sm xl:text-2xl" />
                </a>
                <a
                  href="https://www.linkedin.com/company/iamgemglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#0B69C7] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-md hover:bg-[#084D93cb]"
                >
                  <FaLinkedinIn className="xs:text-base sm:text-sm lg:text-lg xl:text-xl" />
                </a>
                <a
                  href="https://x.com/iamgemglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-black text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-md hover:bg-[#0A95D0cb]"
                >
                  <RiTwitterXLine className="xs:text-sm sm:text-sm lg:text-lg xl:text-xl" />
                </a>
                <a
                  href="https://youtube.com/@gemflix"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#F20000] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-md hover:bg-[#d90000cb]"
                >
                  <FaYoutube className="xs:text-base lg:text-xl sm:text-base xl:text-2xl" />
                </a>
                <a
                  href="https://www.tiktok.com/@iamgemglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#000000] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-md group hover:bg-[#25F4EE]"
                >
                  <FaTiktok className="xs:text-base lg:text-xl sm:text-base xl:text-xl text-secondary group-hover:text-[#000000]" />
                </a>
              </div> */}
              <h4 className="font-unboundedBold text-secondary xs:text-base sm:text-base xl:text-2xl capitalize xs:mt-3 sm:mt-3 lg:mt-8 margin-mob">
                Download the App
              </h4>
              <div className="flex items-center gap-3 xs:mt-4 sm:mt-4 lg:mt-6">
                
                <a  href="https://apps.apple.com/us/app/gem-global/id6755765029" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-all duration-300 transform hover:scale-105 shadow"
                >
                  <img
                    src={AppStoreIcon}
                    alt="Download on App Store"
                    className="xs:h-9 sm:h-9 lg:h-10 xl:h-12 w-auto"
                  />
                </a>
                
                <a  href="https://play.google.com/store/apps/details?id=com.geminc.gem" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-all duration-300 transform hover:scale-105 shadow"
                >
                  <img
                    src={GooglePlayIcon}
                    alt="Get it on Google Play"
                    className="xs:h-9 sm:h-9 lg:h-10 xl:h-12 w-auto"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 xs:w-11/12 left-1/2 transform -translate-x-1/2">
          <img
            src={Img.gemlogoImg}
            className="sm:w-2/3 lg:w-2/4 xl:w-3/4 m-auto"
            alt="gem logo"
          />
        </div>
      </div>
      <div className="bg-[#d9a239] flex justify-center items-center xs:flex-col xs:px-5 xs:py-4 sm:p-5 lg:px-10 xs:my-8  sm:mt-4 lg:mt-5 " >
        <div className="text-[#333333] font-onestRegular text-sm font-onestRegular text-sm lg:w-4/5 xs:w-full sm:w-2/3">
          Copyright © {currentYear} Global Entertainment Movement
        </div>
        <div className="text-[#333333] font-onestRegular text-sm xs:justify-center xs:items-center xs:pt-3 lg:w-2/6 sm:w-5/12 flex justify-end ">
          <span
            className="underline hover:text-secondary cursor-pointer"
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms and Conditions
          </span>{" "}
          |{" "}
          <span
            className="underline hover:text-secondary cursor-pointer"
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
